import script from "./EAvatar.vue?vue&type=script&lang=ts&setup=true"
export * from "./EAvatar.vue?vue&type=script&lang=ts&setup=true"

import "./EAvatar.vue?vue&type=style&index=0&id=58734884&scoped=true&lang=css"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-58734884"]])

export default __exports__